import React, { useState } from "react";
import axios from "axios";
import { Sidebar } from "../components/Sidebar";
import backgroundImage from "../assets/Profile.jpg";

const FileUpload = () => {
  const [files, setFiles] = useState([]);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState("");
  const [downloadLink, setDownloadLink] = useState("");
  const [showDownload, setShowDownload] = useState(false);

  // Handle file selection (from input)
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    
    if (selectedFiles.length === 0) {
      setFiles([]);
      console.log("No file selected.");
      return;
    }

    setFiles(selectedFiles);
    console.log("Files selected:", selectedFiles.map(file => file.name));
  };

  const handleUpload = async () => {
    if (files.length === 0) {
      setMessage("Please select at least one file.");
      return;
    }

    setMessage("");
    setProgress(0);
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));

    try {
      const response = await axios.post(
        "https://myob-to-xero-1059540737346.us-central1.run.app/upload",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) => {
            let percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            const interval = setInterval(() => {
              setProgress((prev) => {
                if (prev >= percent) {
                  clearInterval(interval);
                  return percent;
                }
                return prev + 5;
              });
            }, 100);
          },
        }
      );

      if (response.data.message) {
        setMessage("Files processed successfully!");
        setDownloadLink("https://myob-to-xero-1059540737346.us-central1.run.app/download");
        setShowDownload(true);
        setTimeout(() => {
          setProgress(0);
          setFiles([]);
          document.getElementById("fileInput").value = "";
        }, 3000);
      }
    } catch (error) {
      console.error("Upload error:", error);
      setMessage(error.response?.data?.error || "Error uploading files. Please try again.");
    }
  };

  const handleDownloadClick = () => {
    setShowDownload(false);
  };

  return (
    <div
      className="relative min-h-screen flex flex-col items-center justify-center bg-cover bg-center px-4 sm:px-6 lg:px-8"
      style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: "cover", backgroundPosition: "center" }}
    >
      <Sidebar />
      <div className="bg-black bg-opacity-40 p-6 sm:p-8 rounded-lg shadow-lg text-white w-full max-w-5xl sm:ml-32">
        <h2 className="text-xl sm:text-2xl font-bold text-center mb-4">Ledger Conversion MYOB to Xero FA File</h2>
        <div className="mb-4">
          <label htmlFor="fileInput" className="block text-white font-bold">
            Select XLSX & XLS File:
          </label>
          <input
            type="file"
            id="fileInput"
            name="files"
            onChange={handleFileChange}
            className="block w-full text-white border border-gray-500 rounded-md py-2 px-3 sm:px-4 bg-gray-900"
            multiple
          />
          <p className="text-xs sm:text-sm text-white-400 mt-2">
            Note: <strong>File Type 1:</strong> Before you proceed, while importing the text file into Excel, make sure to properly set the rows and columns. Starting from the 8th row, adjust the delimiters to align with their corresponding columns to ensure a smooth process.
          </p>
          <p className="text-xs sm:text-sm mt-3 text-white-400">
            <strong>File Type 2:</strong> Ensure column names match the correct column data before uploading.
          </p>
          <p className="text-xs sm:text-sm mt-3 text-white-400">
            <strong>File Type 3:</strong> Ensure Type 3 files are in .xls format.
          </p>
        </div>
        <button
          className="w-full bg-gray-700 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded-lg transition"
          onClick={handleUpload}
        >
          Upload & Process
        </button>

        {progress > 0 && (
          <div className="relative w-full bg-gray-800 rounded-full h-4 sm:h-5 mt-4 overflow-hidden">
            <div
              className="bg-green-500 h-full flex items-center justify-center text-xs sm:text-sm font-bold text-white transition-all duration-300 ease-in-out"
              style={{ width: `${progress}%` }}
            >
              {progress}%
            </div>
          </div>
        )}

        {message && <p className="mt-4 text-center text-yellow-400 text-xs sm:text-sm">{message}</p>}

        {showDownload && (
          <a
            href={downloadLink}
            className="block w-full text-center bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-lg mt-4 transition"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleDownloadClick}
          >
            Download Processed File
          </a>
        )}
      </div>
    </div>
  );
};

export default FileUpload;
